module.exports = __webpack_public_path__ + "img/login_heada.6da1e58e.png";